@app.directive 'mediaMulti', ($timeout) ->
  restrict: 'E'
  scope: {}
  controllerAs: 'mediaMulti'
  controller: ->
    @activeIndex = 0
    @active = true
    @autoplay = false

    @selectMedia = (index) =>
      @active = false
      @activeIndex = index
      @autoplay = true
      $timeout (=>
        @active = true
      ), 100

    @activeItem = =>
      @content.items[@activeIndex]

    @toggleActive = =>
      @active = !@active

    this

  link: (scope, element, attrs) ->

  bindToController: {
    content: '='
    theme: '='
    activeIndex: '='
  }
  templateUrl: "/assets/templates/components/media/mediaMulti.html"
